var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState, } from 'react';
import cn from 'classnames';
import { FileUploaderTitle } from './FileUploaderTitle';
import { FileUploaderList } from './FileUploaderList';
import "./styles.css";
export var FileUploader = forwardRef(function (_a, ref) {
    var _b = _a.title, title = _b === void 0 ? 'Перетащите сюда файлы или' : _b, _c = _a.dragOverTitle, dragOverTitle = _c === void 0 ? 'Отпустите сюда файлы для загрузки' : _c, _d = _a.linkName, linkName = _d === void 0 ? 'загрузите документы' : _d, subTitle = _a.subTitle, helperText = _a.helperText, _e = _a.multiple, multiple = _e === void 0 ? false : _e, fileList = _a.fileList, _f = _a.hideFileList, hideFileList = _f === void 0 ? false : _f, onChange = _a.onChange, onDrop = _a.onDrop, onRefresh = _a.onRefresh, onRemove = _a.onRemove, _g = _a.disabled, disabled = _g === void 0 ? false : _g, _h = _a.error, error = _h === void 0 ? false : _h, className = _a.className, props = __rest(_a, ["title", "dragOverTitle", "linkName", "subTitle", "helperText", "multiple", "fileList", "hideFileList", "onChange", "onDrop", "onRefresh", "onRemove", "disabled", "error", "className"]);
    var _j = useState([]), files = _j[0], setFiles = _j[1];
    var _k = useState(false), dragOver = _k[0], setDragOver = _k[1];
    var _l = useState(0), inputKey = _l[0], setInputKey = _l[1];
    var inputRef = useRef(null);
    useImperativeHandle(ref, function () { return inputRef.current; });
    useEffect(function () {
        if (fileList) {
            setFiles(Array.from(fileList));
            // Не забываем обновить files в самом инпуте.
            setInputFiles(Array.from(fileList));
        }
    }, [fileList]);
    var setInputFiles = function (fileList) {
        var inputObj = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current;
        if (!inputObj) {
            return;
        }
        var dt = new DataTransfer();
        Array.from(fileList).map(function (file) {
            dt.items.add(new File([file], file.name));
        });
        inputObj.files = dt.files;
    };
    var changeListener = function (event) {
        filesChange();
        handleDragLeave();
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
        setInputKey(function (prev) { return prev + 1; });
    };
    var filesChange = function () {
        var inputObj = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current;
        if (!inputObj) {
            return;
        }
        var newFiles = inputObj === null || inputObj === void 0 ? void 0 : inputObj.files;
        var list = newFiles ? Array.from(newFiles) : [];
        setFiles(list);
    };
    useEffect(function () {
        var inputObj = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current;
        if (inputObj) {
            inputObj === null || inputObj === void 0 ? void 0 : inputObj.addEventListener('change', changeListener);
        }
        return function () {
            inputObj === null || inputObj === void 0 ? void 0 : inputObj.removeEventListener('change', changeListener);
        };
    }, [inputKey]); //Грязный Гарри хак: инкремент позволяет перепривязать обработчик на событие, терялась привязка, обработчик из вне по ref не срабатывал на "change"
    var handleDragOver = function () {
        setDragOver(true);
    };
    var handleOnDrop = function (event) {
        event.preventDefault();
        event.stopPropagation();
        filesChange();
        handleDragLeave();
        onDrop === null || onDrop === void 0 ? void 0 : onDrop(event);
    };
    var handleDragLeave = function () {
        setDragOver(false);
    };
    var refreshFile = function (file) {
        onRefresh === null || onRefresh === void 0 ? void 0 : onRefresh(file);
    };
    var removeFile = function (file) {
        var inputObj = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current;
        if (!inputObj)
            return;
        var oldFiles = inputObj === null || inputObj === void 0 ? void 0 : inputObj.files;
        if (!oldFiles)
            return;
        var dt = new DataTransfer();
        for (var i = 0; i < oldFiles.length; i++) {
            var oldFile = oldFiles.item(i);
            if (!oldFile) {
                continue;
            }
            var name_1 = oldFile.name, options = __rest(oldFile, ["name"]);
            if (oldFile.name !== file.name) {
                var file_1 = new File([oldFile], oldFile.name, options);
                dt.items.add(file_1);
            }
        }
        inputObj.files = dt.files;
        onRemove === null || onRemove === void 0 ? void 0 : onRemove(file);
        inputObj.dispatchEvent(new Event('change'));
    };
    return (React.createElement("section", { className: cn('lk-ui_file-uploader-wrapper', disabled && 'lk-ui_file-uploader-wrapper__disabled', className) },
        React.createElement("div", { className: cn('lk-ui_file-uploader', dragOver && 'lk-ui_file-uploader__drag-over', error && 'lk-ui_file-uploader__error') },
            React.createElement(FileUploaderTitle, { title: title, dragOver: dragOver, subTitle: subTitle, dragOverTitle: dragOverTitle, linkName: linkName }),
            React.createElement("input", __assign({}, props, { disabled: disabled, type: 'file', multiple: multiple, ref: inputRef, onDrop: onDrop && handleOnDrop, onDragOver: handleDragOver, onDragLeave: handleDragLeave, onDragEnd: handleDragLeave, className: 'lk-ui_file-uploader-input' }))),
        helperText && (React.createElement("sup", { className: 'lk-ui_file-uploader-helper-text' }, helperText)),
        !hideFileList && (React.createElement(FileUploaderList, { files: files, onRemove: removeFile, onRefresh: refreshFile }))));
});
